import { createContext, useContext } from "react";
const WixRicosViewerContext = createContext(void 0);
function useWixRicosViewer() {
  const context = useContext(WixRicosViewerContext);
  if (context === void 0) {
    throw new Error(
      "useWixRicosViewer must be used within a WixRicosViewerContext.Provider"
    );
  }
  return context;
}
export {
  WixRicosViewerContext,
  useWixRicosViewer
};
//# sourceMappingURL=ricos-viewer-context.js.map
